import {PagesHeaderFooter, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import PageMode from "./PageMode";

export class PortalPagesHeaderFooter extends PagesHeaderFooter implements Parameter {
	public mode?: PageMode;
	public from?: number;
	public to?: number;

	constructor(data: any) {
		super(data);

		this.mode = FunctionHelper.exists(data?.mode) ? data.mode : PageMode.All;
		this.from = FunctionHelper.exists(data?.from) ? data.from : 1;
		this.to = FunctionHelper.exists(data?.to) ? data.to : 1;
	}

	public static getModeDefault(): PageMode {
		return PageMode.All;
	}

	public static getFromDefault(): number {
		return 1;
	}

	public static getFromMin(): number {
		return 1;
	}

	public static getToDefault(): number {
		return 1;
	}

	public static getToMin(): number {
		return 1;
	}

	public static fromJson(data: any): PortalPagesHeaderFooter {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalPagesHeaderFooter(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'mode': this.mode,
			'from': this.from,
			'to': this.to
		};
	}

	public clone(): PortalPagesHeaderFooter {
		return PortalPagesHeaderFooter.fromJson(this.toJson());
	}
}